import React, { useState } from 'react';
import { API_ENDPOINTS } from '../config/api';
import { apiService } from '../config/apiService';

const RegistrationForm: React.FC = () => {
    const [name, setName] = useState('');
    const [field1, setField1] = useState('');
    const [photo, setPhoto] = useState<File | null>(null);
    const [createdUuid, setCreatedUuid] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setIsLoading(true);
        setError(null);
        
        const formData = new FormData();
        formData.append('name', name);
        formData.append('campo1', field1);
        if (photo) {
            formData.append('photo', photo);
        }

        try {
            const response = await apiService.postWithCSRF(API_ENDPOINTS.REGISTRATIONS, formData, true);
            
            if (response.ok) {
                const data = await response.json();
                setCreatedUuid(data.id || data.uuid);
                setName('');
                setField1('');
                setPhoto(null);
                setError(null);
                
                // Reset do input de arquivo
                const fileInput = document.getElementById('photo') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }
            } else {
                const errorData = await response.json().catch(() => ({}));
                setError(errorData.detail || `Erro ${response.status}: ${response.statusText}`);
                setCreatedUuid(null);
            }
        } catch (error) {
            console.error('Erro ao enviar formulário:', error);
            setError('Erro de conexão. Tente novamente.');
            setCreatedUuid(null);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="name">Name:</label>
                    <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        disabled={isLoading}
                    />
                </div>
                <div>
                    <label htmlFor="field1">Campo 1:</label>
                    <input
                        type="text"
                        id="field1"
                        value={field1}
                        onChange={(e) => setField1(e.target.value)}
                        required
                        disabled={isLoading}
                    />
                </div>
                <div>
                    <label htmlFor="photo">Photo:</label>
                    <input
                        type="file"
                        id="photo"
                        accept="image/jpeg"
                        onChange={(e) => setPhoto(e.target.files?.[0] || null)}
                        required
                        disabled={isLoading}
                    />
                </div>
                <button type="submit" disabled={isLoading}>
                    {isLoading ? 'Enviando...' : 'Register'}
                </button>
            </form>
            
            {error && (
                <div style={{ 
                    marginTop: 16, 
                    background: "#ffebee", 
                    color: "#c62828",
                    padding: 10, 
                    borderRadius: 8,
                    border: "1px solid #f8bbd9"
                }}>
                    <strong>Erro:</strong> {error}
                </div>
            )}
            
            {createdUuid && (
                <div style={{ 
                    marginTop: 16, 
                    background: "#e8f5e8", 
                    color: "#2e7d32",
                    padding: 10, 
                    borderRadius: 8,
                    border: "1px solid #81c784"
                }}>
                    <strong>✅ Registro criado com sucesso!</strong><br/>
                    <strong>UUID:</strong> {createdUuid}
                </div>
            )}
        </>
    );
};

export default RegistrationForm;